// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"f70d3a6d","456":"b138e9c9","533":"3c21138b"}[chunkId] + ".chunk.css";
};